module.exports = __webpack_public_path__ + "img/18-1.41c05675.png";